import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private logger: LoggingService) {}

  handleError(error: any): void {
    this.logger.logException(error);
    console.error(error);
  }
}
